module.exports = __webpack_public_path__ + "static/media/done.e249914e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/done.svg
// module id = 724
// module chunks = 1